<!-- =========================================================================================
    File Name: ChatContact.vue
    Description: Chat contact - single component for chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="chat__contact flex items-center px-2 pt-4 pb-2" :class="{'bg-primary-gradient text-white shadow-lg': isActiveChatUser}">
        <div class="contact__avatar mr-1">
            <vs-avatar class="border-2 border-solid border-white" :src="contact.iconUrl" size="42px" />
        </div>
        <div class="contact__container w-full flex items-center justify-between overflow-hidden">
            <div class="contact__info chat-contact-info-details flex flex-col truncate pr-2 w-4/6">
                <!-- <h5 class="font-semibold" :class="{'text-white': isActiveChatUser}">{{ contact.name }}</h5> -->
                <vx-tooltip :text="contact.name" position="bottom" >
                  <h5 class="font-semibold" :class="{'text-white': isActiveChatUser}">{{ contact.name }}</h5>
                </vx-tooltip>
                <span class="truncate">{{ contact.description }}</span>
            </div>

            <div class="chat__contact__meta flex self-start flex-col items-end w-2/6">
                <span class="whitespace-no-wrap">{{ showdateTime(contact.createdDateTime) }}</span>
                <!-- <vs-chip class="number" color="warning" v-if="reportMsg">{{ reportMsg }}</vs-chip> -->
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  props: {
    contact          : { type: Object,  required: true },
    isActiveChatUser : { type: Boolean },
    lastMessaged     : { type: String,  default : '' },
    showLastMsg      : { type: Boolean, default: false },
    reportMsg        : { type: Number,  default : 10 }
  },
  
  methods:{
    showdateTime(val){
        return moment(val.seconds*1000).format('MMM DD, YYYY')
    }
  }
}
</script>

